import { __assign } from "tslib";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { $el, bind } from '../../dom-utils';
import { CssTransition, Scrollable } from '../../mixins';
import { type, useHTMLString } from '../../utils';
import Button from '../button';
import PREFIX from '../prefix';
var MiniModalBtn = new Button();
var ICONTYPE = {
    info: 'ios-information-circle',
    success: 'ios-checkmark-circle',
    warning: 'ios-alert',
    error: 'ios-close-circle',
    confirm: 'ios-help-circle',
    loading: 'loading-solid'
};
var DEFAULT_ZINDEX = 1010;
var MiniModal = /** @class */ (function () {
    function MiniModal() {
        this.VERSION = 'v1.0';
    }
    MiniModal.prototype.info = function (config) {
        this._create('info', config);
    };
    MiniModal.prototype.success = function (config) {
        this._create('success', config);
    };
    MiniModal.prototype.warning = function (config) {
        this._create('warning', config);
    };
    MiniModal.prototype.error = function (config) {
        this._create('error', config);
    };
    MiniModal.prototype.confirm = function (config) {
        this._create('confirm', config);
    };
    MiniModal.prototype.remove = function () {
        var _a = this._getNode(), ModalParent = _a.ModalParent, ModalMask = _a.ModalMask, ModalWrap = _a.ModalWrap;
        this._destroy(ModalParent, ModalMask, ModalWrap);
    };
    MiniModal.prototype._create = function (type, config) {
        DEFAULT_ZINDEX++;
        var _a = config.width, width = _a === void 0 ? 416 : _a, _b = config.title, title = _b === void 0 ? '' : _b, _c = config.content, content = _c === void 0 ? '' : _c, _d = config.okText, okText = _d === void 0 ? '确定' : _d, _e = config.cancelText, cancelText = _e === void 0 ? '取消' : _e, _f = config.loading, loading = _f === void 0 ? false : _f, _g = config.keyboard, keyboard = _g === void 0 ? false : _g, _h = config.scrollable, scrollable = _h === void 0 ? false : _h, _j = config.lockScroll, lockScroll = _j === void 0 ? true : _j, onOk = config.onOk, onCancel = config.onCancel, _k = config.dangerouslyUseHTMLString, dangerouslyUseHTMLString = _k === void 0 ? false : _k;
        // @ts-ignore
        var icon = ICONTYPE[type];
        var isShowCancelBtn = type === 'confirm'
            ? "<button type=\"button\" class=\"" + PREFIX.button + " " + PREFIX.button + "-text\">" + cancelText + "</button>"
            : '';
        var template = "\n        <div class=\"" + PREFIX.modal + "-mini-modal\">\n          <div class=\"" + PREFIX.modal + "-mask\" style=\"z-index: " + DEFAULT_ZINDEX + ";\"></div>\n          <div class=\"" + PREFIX.modal + "-wrap\" style=\"z-index: " + DEFAULT_ZINDEX + ";\">\n              <div class=\"" + PREFIX.modal + "\" style=\"width: " + width + "px;\">\n                  <div class=\"" + PREFIX.modal + "-content\">\n                      <div class=\"" + PREFIX.modal + "-body\">\n                          <div class=\"" + PREFIX.modal + "-confirm\">\n                              <div class=\"" + PREFIX.modal + "-confirm-head\">\n                                  <div class=\"" + PREFIX.modal + "-confirm-head-icon " + PREFIX.modal + "-confirm-head-icon-" + type + "\">\n                                      <i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-" + icon + "\"></i>\n                                  </div>\n                                  <div class=\"" + PREFIX.modal + "-confirm-head-title\"></div>\n                              </div>\n                              <div class=\"" + PREFIX.modal + "-confirm-body\"></div>\n                              <div class=\"" + PREFIX.modal + "-confirm-footer\">\n                                  " + isShowCancelBtn + "\n                                  <button type=\"button\" class=\"" + PREFIX.button + " " + PREFIX.button + "-primary\"><span>" + okText + "</span></button>\n                              </div>\n                          </div>\n                      </div>\n                  </div>\n              </div>\n          </div>\n        </div>";
        document.body.insertAdjacentHTML('beforeend', template);
        var _l = this._getNode(), ModalParent = _l.ModalParent, ModalMask = _l.ModalMask, ModalWrap = _l.ModalWrap, Modal = _l.Modal;
        this._setMainContent(Modal, title, content, dangerouslyUseHTMLString);
        this._setAnimation('in', ModalMask, ModalWrap);
        this._setScrollable(scrollable, lockScroll);
        this._handleBtnClick(ModalParent, ModalMask, ModalWrap, Modal, loading, onOk, onCancel);
        this._keyboardClosed(type, keyboard, ModalParent, ModalMask, ModalWrap, onCancel);
    };
    MiniModal.prototype._setMainContent = function (modal, title, content, isUseHTML) {
        var ModalHead = modal.querySelector("." + PREFIX.modal + "-confirm-head-title");
        var ModalBody = modal.querySelector("." + PREFIX.modal + "-confirm-body");
        useHTMLString(ModalHead, title, isUseHTML);
        useHTMLString(ModalBody, content, isUseHTML);
    };
    MiniModal.prototype._handleBtnClick = function (parent, mask, wrap, modal, loading, onOk, onCancel) {
        var _this = this;
        var ModalOkBtn = modal.querySelector("." + PREFIX.button + "-primary");
        var ModalCacnelBtn = modal.querySelector("." + PREFIX.button + "-text");
        var remove = function () { return _this._destroy(parent, mask, wrap); };
        var okEv = function () {
            onOk && type.isFn(onOk);
            if (loading) {
                MiniModalBtn.config(ModalOkBtn).loading = loading;
                return;
            }
            remove();
        };
        var cancelEv = function () {
            remove();
            onCancel && type.isFn(onCancel);
        };
        bind(ModalOkBtn, 'click', okEv);
        if (ModalCacnelBtn)
            bind(ModalCacnelBtn, 'click', cancelEv);
    };
    MiniModal.prototype._keyboardClosed = function (_type, keyboard, parent, mask, wrap, onCancel) {
        var _this = this;
        if (!keyboard)
            return;
        var event = function (e) {
            if (e.key === 'Escape') {
                e.stopPropagation();
                // 判断页面是否有modal实例，如果有才执行事件，避免重复执行
                if (document.body.contains(parent)) {
                    // 取消的回调，只在MinModal.confirm()下有效
                    if (_type === 'confirm')
                        onCancel && type.isFn(onCancel);
                    setTimeout(function () { return _this._destroy(parent, mask, wrap); }, 0);
                }
            }
        };
        window.onkeydown = function (e) { return event(e); };
    };
    MiniModal.prototype._destroy = function (parent, mask, wrap) {
        var _this = this;
        this._setAnimation('out', mask, wrap);
        setTimeout(function () {
            parent.remove();
            _this._setScrollable(true, false);
        }, 150);
    };
    MiniModal.prototype._setAnimation = function (type, elem1, elem2) {
        var maskAniCls = type === 'in' ? { enterCls: 'rab-fade-in' } : { leaveCls: 'rab-fade-out' };
        var modalAniCls = type === 'in' ? { enterCls: 'zoom-big-enter' } : { leaveCls: 'zoom-big-leave' };
        CssTransition(elem1, __assign(__assign({ inOrOut: type }, maskAniCls), { timeout: 250, rmCls: true }));
        CssTransition(elem2, __assign(__assign({ inOrOut: type }, modalAniCls), { timeout: 200, rmCls: true }));
    };
    MiniModal.prototype._setScrollable = function (scrollable, lockScroll) {
        Scrollable({ scroll: scrollable, lock: lockScroll });
    };
    MiniModal.prototype._getNode = function () {
        var ModalParent = $el("." + PREFIX.modal + "-mini-modal");
        var ModalMask = ModalParent.querySelector("." + PREFIX.modal + "-mask");
        var ModalWrap = ModalParent.querySelector("." + PREFIX.modal + "-wrap");
        var Modal = ModalWrap.querySelector("." + PREFIX.modal);
        return {
            ModalParent: ModalParent,
            ModalMask: ModalMask,
            ModalWrap: ModalWrap,
            Modal: Modal
        };
    };
    return MiniModal;
}());
export default MiniModal;
